// @react-compiler enable
import {testIdProps} from '@github-ui/test-id-props'
import {memo} from 'react'

import type {Label} from '../../../api/common-contracts'
import {ItemType} from '../../../api/memex-items/item-type'
import {TableRowHeight} from '../../../api/view/contracts'
import {useTableRowHeight} from '../../../hooks/use-table-row-height'
import {type ColumnValue, hasValue, isLoading} from '../../../models/column-value'
import type {MemexItemModel} from '../../../models/memex-item-model'
import {PillPlaceholder} from '../../common/placeholders'
import {BaseCell} from '../cells/base-cell'
import {DropdownCell} from '../cells/dropdown-cell'
import {LabelGroup} from '../cells/label-group'
import {useRecordCellRenderer} from '../performance-measurements'

type Props = Readonly<{
  currentValue: ColumnValue<Array<Label>>
  model: MemexItemModel
  dropdownRef?: React.RefObject<HTMLButtonElement | null>
  isDisabled?: boolean
}>

export const LoadingLabelsCell = () => (
  <BaseCell>
    <PillPlaceholder minWidth={30} maxWidth={60} {...testIdProps('placeholder')} />
  </BaseCell>
)

export const LabelsRenderer = memo(function LabelsRenderer({currentValue, model, dropdownRef, isDisabled}: Props) {
  useRecordCellRenderer('LabelsRenderer', model.id)
  const {rowHeight} = useTableRowHeight()

  const columnValue = hasValue(currentValue) ? currentValue.value : undefined
  const isWrapping = rowHeight !== TableRowHeight.Single

  if (isLoading(currentValue)) {
    return <LoadingLabelsCell />
  }

  if (model.contentType === ItemType.DraftIssue) {
    return <DropdownCell ref={dropdownRef} isDisabled={isDisabled} />
  }

  return <LabelGroup labels={columnValue} dropdownRef={dropdownRef} isDisabled={isDisabled} isWrapping={isWrapping} />
})
